import Link from 'next/link';
import emojiFlags from 'emoji-flags';
import { getLocationDetails } from '../../../helpers/getLocationDetails';

// Self-hosted Twemoji SVG (public/flags) — a ~1KB image instead of pulling
// the 79KB flags webfont onto every post's critical path. The webfont stays
// as a fallback for flag emojis inside user content (unicode-range scoped).
export function flagSrc(countryCode) {
  if (!countryCode || !emojiFlags.countryCode(countryCode.toUpperCase()))
    return null;
  return `/flags/${countryCode.toLowerCase()}.svg`;
}

// The post's location as a mono passport chip. `onPhoto` renders the
// light-on-photo variant used over the cinematic hero — fixed light ink in
// both themes (the photo doesn't change with the theme, so neither may the
// chip), backdrop-blurred against busy covers.
export default function LocationChip({ location, onPhoto }) {
  if (!location || !location.countryCode) return null;
  const { locationSubtitle, locationLink } = getLocationDetails(location);
  const flag = flagSrc(location.countryCode);

  return (
    <Link
      href={locationLink}
      prefetch={false}
      className={`tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-border tw-border-solid tw-px-3.5 tw-py-1.5 tw-font-mono tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-[0.18em] tw-no-underline tw-transition-colors ${
        onPhoto
          ? 'tw-border-[rgba(255,255,255,0.38)] tw-bg-[rgba(12,20,17,0.35)] tw-text-[#F5F1E6] tw-backdrop-blur-sm hover:tw-bg-[rgba(12,20,17,0.55)]'
          : 'tw-border-primary-600/25 dark:tw-border-primary-300/25 tw-bg-primary-600/[0.06] dark:tw-bg-primary-300/10 tw-text-primary-800 dark:tw-text-primary-200 hover:tw-bg-primary-600/[0.14]'
      }`}
    >
      {flag && (
        <img
          src={flag}
          alt=""
          aria-hidden="true"
          width={14}
          height={14}
          loading="eager"
          className="tw-h-[14px] tw-w-[14px]"
        />
      )}
      {locationSubtitle}
    </Link>
  );
}
